import { PluginKey } from 'prosemirror-state'

export const INLINE_LINK_MENU_PLUGIN_KEY = new PluginKey('InlineLinkMenuPluginKey')
export const INLINE_LINK_ID = 'inline-link-menu'
